import { createFileRoute, redirect } from "@tanstack/react-router";
import { z } from "zod";
import { useAuth } from "../../../components/AuthProvider";
import { createRouteError } from "../../../components/RouteErrorBoundary";
import { PageSkeleton } from "../../../components/RouteSkeleton";
import { NotebookWorkbench } from "@/components/admin/notebooks/NotebookWorkbench";

const workbenchSearchSchema = z.object({
  thread: z.string().uuid().optional(),
  focus: z.union([z.literal("1"), z.literal("true"), z.boolean()]).optional(),
});

export const Route = createFileRoute("/_admin/notebooks/$notebookId")({
  validateSearch: workbenchSearchSchema,
  beforeLoad: async ({ context }) => {
    if (typeof window === "undefined") return {};
    const sb = context.supabase;
    if (!sb) return {};
    const {
      data: { session },
    } = await sb.auth.getSession();
    if (!session) {
      throw redirect({ to: "/auth" });
    }
    return { session };
  },
  pendingComponent: () => <PageSkeleton rows={6} variant="cards" />,
  errorComponent: createRouteError("Notebook"),
  component: NotebookWorkbenchRoutePage,
});

function NotebookWorkbenchRoutePage() {
  const { loading, isAuthenticated } = useAuth();
  const { notebookId } = Route.useParams();
  const { thread } = Route.useSearch();

  if (loading || !isAuthenticated) {
    return (
      <div className="flex items-center justify-center py-12">
        <p className="text-muted-foreground">Loading...</p>
      </div>
    );
  }

  return <NotebookWorkbench notebookId={notebookId} threadId={thread} />;
}
